import { render } from "./Global.vue?vue&type=template&id=02b0b6ea&scoped=true&ts=true"
import script from "./Global.vue?vue&type=script&lang=ts"
export * from "./Global.vue?vue&type=script&lang=ts"

import "./Global.vue?vue&type=style&index=0&id=02b0b6ea&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02b0b6ea"]])

export default __exports__